import { render, staticRenderFns } from "./SidebarSwitcher.vue?vue&type=template&id=f1510202&scoped=true&lang=pug&"
import script from "./SidebarSwitcher.vue?vue&type=script&lang=ts&"
export * from "./SidebarSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1510202",
  null
  
)

export default component.exports